import { gql } from '@apollo/client';

export interface OptimizationParentJobsResponse {
    allReportJobs: {
        nodes: Array<{
            parentJobId: string;
        }>;
    };
}

export interface OptimizationParentJobsQueryVariables {
    workspaceID?: string;
    orderBy: string;
}

export default gql`
  query OptimizationParentJobsQuery(
    $workspaceID: Int
    $orderBy: [ReportJobsOrderBy!]
  ) {
    allReportJobs(
      condition: { workspaceId: $workspaceID, reportStatus: SUCCESS }
      filter: { reportType: { equalTo: "optimization" } }
      orderBy: $orderBy
    ) {
      nodes {
        parentJobId
      }
    }
  }
`;
